import { postFetch, getFetch } from '@/utils/request'

export function getOrderListData(pageNum, orderQuery) {
    return postFetch('/order/getOrderList', {pageNum: pageNum}, orderQuery)
}

export function getOrerStatusesData() {
    return getFetch('/order/getOrerStatuses', {})
}

export function getOrderDetailData(orderId) {
    return getFetch('/order/getOrderDetail', {orderId: orderId})
}

export function auditNotpassOrderData(orderId) {
    return getFetch('/order/auditNotpassOrder', {orderId: orderId})
}
export function aliPay(orderCode){
    return getFetch('aliPay/requestPayment',{orderCode:orderCode})
}
export function wxPay(orderCode){
  return getFetch('wxPay/requestPayment',{orderCode:orderCode})
}
export function wxApply(orderCode){
    return getFetch('/wxPay/tradeQuery',{orderCode:orderCode})
  }
export function getOrderDetailByOrderCode(orderCode){
    return getFetch('/order/getOrderDetailByOrderCode',{orderCode:orderCode})
}


export function confirmOrder(orderCode){
    return getFetch('/order/confirmOrder',{orderCode:orderCode})
}

export function rejectOrder(orderCode,customerRemark){
    return getFetch('/order/rejectOrder',{orderCode:orderCode,customerRemark:customerRemark})
}


// WEBPACK FOOTER //
// ./src/api/customer/orderApi.js